<app-card>
  <ng-container cardBody>
    <div [innerHTML]="data.value.product_usage"></div>
  </ng-container>
</app-card>
<div class="mt-10">
  <app-card class="">
    <ng-container cardBody>
      <div [innerHTML]="data.value.description"></div>
    </ng-container>
  </app-card>
</div>
